<template>
  <base-icon
    icon="list"
    :action="goTo"
    title="メンバー状況"
  />
</template>

<script>
import BaseIcon from './Base'

export default {
  components: {
    BaseIcon
  },

  methods: {
    goTo () {
      const routeData = this.$router.resolve({ name: 'members' })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
